import React from "react";

const VIOLETA = "#697B68";
const ROSA = "#E09767";

export default function Youtube() {
  const arrayVideos = [
    {
      url: "https://www.youtube.com/embed/8G6q1Afn-jI?si=WmOt_TWwfEL12PJC",
      titulo: "Qué es el desarrollo web | Aplicación Web",
    },
    {
      url: "https://www.youtube.com/embed/Iq3R-1yKb90?si=mx2ilGlfA2DqBRhO",
      titulo: "Tecnologías para hacer una app sencilla",
    },
    {
      url: "https://www.youtube.com/embed/kOyAccERmqo?si=Pw1aWxf1osAlo4c-",
      titulo: "Cómo desplegar una app en Vercel",
    },
    {
      url: "https://www.youtube.com/embed/0x0PDBkih3Y?si=890j4-2vPMtLgv-7",
      titulo: "Loader moderno para tu app",
    },
  ];

  return (
    <section className="flex w-full justify-center">
      <div
        className="card-padding w-full min-w-0 rounded-[1.5rem] bg-white/95 shadow-2xl"
        style={{ border: `1px solid ${VIOLETA}1A` }}
      >
        {/* Encabezado */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10">
          <div className="flex flex-col items-center gap-6 text-center lg:flex-row lg:text-left">
            <img
              src="https://cdn.prod.website-files.com/6060e6c66acd5a7636de522c/64d68edb50a70ee26eebc10e_yt_logo_mono_light.png"
              alt="YouTube"
              className="h-8 w-auto max-w-full shrink-0 md:h-10"
            />
            <h3
              className="card-title tracking-tight"
              style={{ color: VIOLETA }}
            >
              ¡Aprendé y crecé conmigo en mis proyectos!
            </h3>
          </div>
        </div>

        {/* Grid de videos */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {arrayVideos.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col items-center text-center rounded-2xl overflow-hidden border transition-all duration-300 hover:shadow-xl"
              style={{
                borderColor: `${VIOLETA}1A`,
                backgroundColor: "rgba(255,255,255,0.95)",
              }}
            >
              <div className="relative w-full aspect-[9/16] overflow-hidden">
                <iframe
                  src={`${item.url}&controls=0&modestbranding=1&showinfo=0&rel=0`}
                  title={item.titulo}
                  className="absolute inset-0 w-full h-full rounded-t-2xl"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <p
                className="small-copy p-5 font-medium transition-colors duration-300 group-hover:text-[var(--rosa)]"
                style={{ color: `${VIOLETA}CC`, "--rosa": ROSA }}
              >
                {item.titulo}
              </p>

              {/* línea de acento al hover */}
              <div
                className="h-[3px] w-0 group-hover:w-full transition-all duration-500"
                style={{
                  background: `linear-gradient(135deg, ${ROSA} 0%, ${VIOLETA} 100%)`,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
